import { render, staticRenderFns } from "./AuthTokenLayout.vue?vue&type=template&id=2523de30"
import script from "./AuthTokenLayout.vue?vue&type=script&lang=js"
export * from "./AuthTokenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports